import { DropdownListItemSize } from './dropdown-list.types'

// Note: the design system's dropdown elevation, shared by every dropdown list (Select, menus, ...).
export const DROPDOWN_LIST_SHADOW =
  '0 0.1rem 0.3rem rgba(9, 30, 66, 0.08), 0 0.8rem 1.2rem rgba(9, 30, 66, 0.1)'

export const DROPDOWN_LIST_ITEM_HEIGHT_MAP: Record<DropdownListItemSize, string> = {
  medium: '4rem',
  small: '3.2rem',
}

// Note: the space between a row's items (caret, checkbox/icon, label), the same for both sizes.
export const DROPDOWN_LIST_ITEM_GAP = '0.4rem'

// Note: the row's left/right padding, the same for both sizes.
export const DROPDOWN_LIST_ITEM_PADDING_HORIZONTAL = '1.6rem'

export const DROPDOWN_LIST_ITEM_FONT_SIZE_MAP: Record<DropdownListItemSize, string> = {
  medium: '1.4rem',
  small: '1.2rem',
}

export const DROPDOWN_LIST_ITEM_LINE_HEIGHT_MAP: Record<DropdownListItemSize, string> = {
  medium: '2rem',
  small: '1.6rem',
}

// Note: the size of the leading checkbox/icon slot.
export const DROPDOWN_LIST_ITEM_SLOT_SIZE_MAP: Record<DropdownListItemSize, string> = {
  medium: '2rem',
  small: '1.6rem',
}
